import axios from "axios";


export async function fetchWeeks() {
    let options = [];
    const response = await axios.get('/my-account/list/load-weeks');
    const weeks = response.data.weeks;
    const hasMaster = response.data.hasMaster;

    Object.keys(weeks).map((week) => {
        options.push({ value: week, label: weeks[week] });
    });

    return {options, hasMaster};
}